import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import $axios from './index';

// Check for user (GET)
export const checkForUser = createAsyncThunk('check the user', async () => {
  let response = null;
  try {
    response = await $axios.get('/users/me');
    // console.log(response)
    return response.data;
  } catch (error) {
    // console.log('err')
    window.location.href = '/login';
    localStorage.removeItem('at');
    response = error.response;
  }

  return response.data;
});

// user login (POST)
export const loginUser = createAsyncThunk('login user', async (data) => {
  let response = null;
  try {
    response = await $axios.post('/auth/login', { email: data.email, password: data.password });
    console.log('data', response);
    return response.data;
  } catch (error) {
    // console.log('err', error)
    response = error.response;
  }
  console.log(response);
  return response.data;
});

export const forgotPasswordAdmin = createAsyncThunk('auth/forgotPasswordAdmin', async ({ email }, { rejectWithValue }) => {
  try {
    const { data } = await $axios.post('/auth/forgot-password', { email, context: 'admin' });
    return data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || 'Something went wrong');
  }
});

export const resetPasswordAdmin = createAsyncThunk('auth/resetPasswordAdmin', async ({ token, password }, { rejectWithValue }) => {
  try {
    const { data } = await $axios.post(`/auth/reset-password/${encodeURIComponent(token)}`, { password });
    return data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || 'Something went wrong');
  }
});

// Slice
const eComAuthSlice = createSlice({
  name: 'auth-slice',
  initialState: {
    user: null,
    userLoading: false,
    userError: null,
    userAuthError: null,
  },
  reducers: {
    logout(state) {
      state.user = null;
      state.userAuthError = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(checkForUser.fulfilled, (state, action) => {
      state.userLoading = false;
      if (action.payload?.success) {
        state.user = action.payload.data;
        state.userAuthError = null;
      } else {
        state.user = null;
        localStorage.removeItem('at');
        state.userAuthError = action.payload.message || null;
      }
    });

    builder
      .addCase(loginUser.pending, (state) => {
        state.userLoading = true;
        state.userError = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.userLoading = false;
        if (action.payload?.success) {
          state.user = action.payload.data;
          state.userError = null;
          localStorage.setItem('at', action.payload.token);
        } else {
          state.user = null;
          state.userError = action.payload.message;
          localStorage.removeItem('at');
        }
      });

    // Check User
    // builder.addCase(checkForUser.fulfilled, (state, action) => {
    //   state.data.push(action.payload);
    // });
  },
});

export const { logout: logoutUser } = eComAuthSlice.actions;
export default eComAuthSlice.reducer;
